<div class="sign-out-header">
  <div class="logo-container">
    <img src="../assets/images/logo.png" alt="NCSEAA K12 Scholarships" class="logo" />
  </div>
</div>

<div class="sign-out-page">
  <div class="sign-out-container">
    <div class="sign-out-content">
      <h1 class="title">You have been signed out</h1>
      <p class="message">Your session has ended. Sign in again when you are ready to continue.</p>
      <button
        class="save-button"
        data-qa="sign-in-button"
        mat-flat-button
        type="button"
        (click)="signIn()">
        Sign in
      </button>
    </div>
  </div>
</div>
